module.exports = __webpack_public_path__ + "img/plus_btn.bbcf5e1a.png";